import styled from '@emotion/styled'

import { Container } from '@/components/Container'
import { CONFIG } from '@/styles/emotion.config'

export const MediaWithCarouselContainer = styled(Container)`
  .media-with-carousel__content {
    max-width: 100%;
    padding: 1rem;
    margin: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: -1px;

    ${CONFIG.media.lg} {
      padding: 1rem 0;
    }
  }

  .media-with-carousel__title {
    text-align: center;
    padding: 0 2rem;
    margin-bottom: 2rem;
  }

  .media-with-carousel__cta-btn {
    max-width: 24rem;
    width: 100%;

    background-color: rgb(var(--colors-pink));
  }
`
